import { DrumkitPlatform } from 'contexts/sidebarStateContext';

/**
 * Determines if an email can be replied to in a thread based on platform-specific requirements.
 *
 * @param drumkitPlatform - The platform (Outlook, Front, Sidepanel, or None)
 * @param threadId - Outlook / Front conversation ID
 * @param threadItemId - Outlook / Front message/item ID required for Graph API reply operations.
 * @param threadReferences - Gmail/Front thread references
 * @param inReplyTo - Gmail/Front in-reply-to header array
 * @returns true if the email can be replied to in thread, false otherwise
 */
export const checkCanReplyInThread = (
  drumkitPlatform: DrumkitPlatform,
  threadId?: string,
  threadItemId?: string,
  threadReferences?: string,
  inReplyTo?: string[]
): boolean => {
  // Outlook requires threadItemId (the actual message ID) for Graph API reply operations.
  // In compose mode, threadItemId will be empty since draft IDs cannot be used.
  if (drumkitPlatform === DrumkitPlatform.Outlook) {
    return Boolean(threadItemId);
  }

  // Front requires threadID or threadItemID
  if (drumkitPlatform === DrumkitPlatform.Front) {
    return Boolean(threadId || threadItemId);
  }

  // Gmail/Front requires threadReferences and/or inReplyTo
  if (drumkitPlatform === DrumkitPlatform.Sidepanel) {
    return Boolean(threadReferences || (inReplyTo && inReplyTo.length > 0));
  }

  // Unknown platform or None - don't show reply to thread option
  return false;
};
